import reducer from './reducer';

export default reducer;
export { beginLoad, endLoad } from './actions';



// WEBPACK FOOTER //
// ./src/redux/modules/asyncConnect/index.ts